<script>
import AddUpdateUser from "../elements/AddUpdateUser";
import { mapGetters } from "vuex";

export default {
	name: "userCard",
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	components: { AddUpdateUser },
	computed: {
		...mapGetters("users", ["selectedUser"]),
	}
};
</script>

<template>
	<div class="userCard">
		<h2>
			Username: {{ user.username }}
		</h2>
		<div>
			<v-list>
				<v-list-item>
					First Name: {{ user.firstName }}
				</v-list-item>
				<v-list-item>
					Last Name: {{ user.lastName }}
				</v-list-item>
				<v-list-item v-if="user.email">
					<v-icon>mdi-email</v-icon>
					<a :href="'mailto:' + user.email">
						{{ user.email }}
					</a>
				</v-list-item>
				<v-list-item v-if="user.phone">
					<v-icon>mdi-phone</v-icon>
					<a :href="'tel:' + user.phone">
						{{ user.phone }}
					</a>
				</v-list-item>
			</v-list>
		</div>
		<div class="userActions">
			<add-update-user :user="user"/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.userCard {
	margin:16px 6px;
	a {
		text-decoration: none;
		color: inherit;
	}
	i {
		margin-right: 4px;
	}
	.v-list-item {
		padding: 0;
		min-height: 35px;
	}
	h3 {
		padding-bottom: 0;
	}
	.userActions {
		text-align: right;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/layout/UserCard.vue